<template>
  <button
    class="mt-4 button button-primary"
    :class="{ loading: isLoading }"
    @click="handleGenerateChallengeClick"
  >
    <div class="flex justify-center align-center">
      <i v-if="isLoading" class="material-icons mr-2">
        sync
      </i>
      <span>Gerar Desafio</span>
    </div>
  </button>
</template>

<script>
export default {
  name: "ChallengeGeneratorButton",

  data() {
    return {
      isLoading: false
    };
  },
  mounted() {},

  computed: {},
  methods: {
    handleGenerateChallengeClick() {
      if (this.isLoading) {
        return;
      }
      this.isLoading = true;
      this.$store
        .dispatch("generateNewChallenge")
        .then(() => {
          this.isLoading = false;
        })
        .catch(error => {
          this.isLoading = false;
          this.$toasted.error(`Ops... ${error.response.data.message}`);

          if (
            error.response.data.message ===
            "Você não escolheu nenhuma disciplina"
          ) {
            this.$toasted.info(
              `Você ainda não escolheu uma disciplina. Para escolher uma disciplina, vá em "Configurações" e "Disciplinas para Estudar"`
            );
          }
        });
    }
  },

  components: {}
};
</script>
<style lang="scss" scoped>
.loading {
  background-color: lightgray;
}
i {
  animation-name: spin;
  animation-duration: 1500ms;
  animation-iteration-count: infinite;
  animation-timing-function: linear;
}

@keyframes spin {
  from {
    transform: rotate(0deg);
  }
  to {
    transform: rotate(360deg);
  }
}
</style>
